/*jshint -W014 */
import axios from "axios";
import $ from "jquery";
import CommonService from "@/core/utils/common-service";
import i18n from "@/core/locales/i18n";
import { ERROR_CODE } from "@/constants/error-code";

export const axiosInstance = axios.create({
  baseURL: "/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

axiosInstance.interceptors.request.use(request => requestHandler(request));

axiosInstance.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
);

const header = $("meta[name='_csrf_header']").attr("content");
const token = $("meta[name='_csrf']").attr("content");
const sid = $("meta[name='_sid']").attr("content");
axiosInstance.defaults.headers.post[header] = token;
axiosInstance.defaults.headers.put[header] = token;
axiosInstance.defaults.headers.delete[header] = token;
axiosInstance.defaults.headers.patch[header] = token;
axiosInstance.defaults.headers.trace = {};
axiosInstance.defaults.headers.trace[header] = token;
axiosInstance.defaults.headers.sid = sid;

const inRange = (value, min, max) => value >= min && value <= max;

const isHandlerEnabled = (config = {}) => {
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

const isNotRequestBusiness = (config = {}) => {
  return (
    config.hasOwnProperty("isNotHandlerNetwork") && config.isNotHandlerNetwork
  );
};

const requestHandler = request => {
  return request;
};

const errorHandler = error => {
  const wrappedResponse = _wrapAxiosResponse(error.response);
  if (isHandlerEnabled(error.config)) {
    return handlerEnabled(wrappedResponse);
  } else if (
    wrappedResponse.isClientError &&
    wrappedResponse.isNetworkError &&
    !isNotRequestBusiness(error.config)
  ) {
    alert(i18n.t("Error.error_network"));
    return Promise.reject({ ...wrappedResponse });
  } else {
    return Promise.reject({ ...wrappedResponse });
  }
};

function handlerEnabled(wrappedResponse) {
  switch (true) {
    case wrappedResponse.isServerUnavailable:
      window.location.reload();
      break;
    case wrappedResponse.isBadRequest &&
      (wrappedResponse.data.errorCode === ERROR_CODE.ERR_INVALID_ERROR ||
        wrappedResponse.data.errorCode === ERROR_CODE.ERR_UNEXPECTED_ERROR ||
        wrappedResponse.data.errorCode === ERROR_CODE.ERR_PARAM_CHECK_FAIL):
      break;
    case wrappedResponse.isConflict:
    case wrappedResponse.isServerError:
    case wrappedResponse.isUnauthorized:
    case wrappedResponse.isForbidden:
      CommonService.gotoErrorPage(wrappedResponse, "000");
      break;
    case wrappedResponse.isClientError && wrappedResponse.isNetworkError:
      alert(i18n.t("Error.error_network"));
      pingServer();
      break;
    default:
      pingServer();
      break;
  }
  return Promise.reject({ ...wrappedResponse });
}

function pingServer() {
  axiosInstance
    .get("/ping", {
      handlerEnabled: false,
      isNotHandlerNetwork: true
    })
    .then(response => {
      if (response.data === "close") {
        window.location.reload();
      }
    });
}

const successHandler = response => {
  return _wrapAxiosResponse(response);
};

function _wrapAxiosResponse(axiosResponse) {
  let wrappedResponse = {};

  if (axiosResponse !== undefined) {
    wrappedResponse = {
      status: axiosResponse.status,
      statusText: axiosResponse.statusText,
      config: axiosResponse.config,
      headers: axiosResponse.headers,
      data: axiosResponse.data
    };

    wrappedResponse.isOk = wrappedResponse.status === 200;
    wrappedResponse.isCreated = wrappedResponse.status === 201;
    wrappedResponse.isBadRequest = wrappedResponse.status === 400;
    wrappedResponse.isUnauthorized = wrappedResponse.status === 401;
    wrappedResponse.isForbidden = wrappedResponse.status === 403;
    wrappedResponse.isNotFound = wrappedResponse.status === 404;
    wrappedResponse.isConflict = wrappedResponse.status === 409;
    wrappedResponse.isServerError = wrappedResponse.status === 500;
    wrappedResponse.isServerUnavailable = wrappedResponse.status === 503;

    wrappedResponse.isSuccessful = inRange(wrappedResponse.status, 200, 299);
    wrappedResponse.isClientError = inRange(wrappedResponse.status, 400, 499);
    wrappedResponse.isServerError = inRange(wrappedResponse.status, 500, 599);
  } else {
    wrappedResponse = {
      isClientError: true,
      isNetworkError: true
    };
  }

  return wrappedResponse;
}
